import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetFirmAccounts = () => {
  const {
    data: firmAccounts,
    isLoading: firmAccountsLoading,
    error: firmAccountsError,
  } = useAuthenticatedQuery(
    ["firmAccounts"],
    "/api/v1/subscriptions/firm-accounts",
    {
      // Filter only active accounts
      select: (data) =>
        data?.filter((account) => account.is_active === true) || [],
      staleTime: 10 * 60 * 1000, // Cache for 10 minutes
      cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    }
  );

  return {
    firmAccounts,
    firmAccountsLoading,
    firmAccountsError,
  };
};

export default useGetFirmAccounts;
